<template>
    <div class="partner">
        <div>
            <div class="header_btn">
                <el-input class="common_ipt" v-model="goodsName" placeholder="商品名称" clearable />
                <el-input class="common_ipt" v-model="goodsId" placeholder="商品ID" clearable />
                <el-select class="common_ipt" ref="selectRef" v-model="categoryName" placeholder="所属网易类目"
                    @mousedown="openDialog" clearable>
                </el-select>
                <div style="display: flex;align-items: center;margin: 0 10px 10px 0;">
                    <el-input class="common_ipt3" v-model="negotiatedPriceSmall" placeholder="渠道协议最小售价" clearable
                        style="margin-right: 3px;" />-
                    <el-input class="common_ipt3" v-model="negotiatedPriceBig" placeholder="渠道协议最大售价" clearable
                        style="margin-left: 3px;" />
                </div>
                <el-select class="force-style-input " v-model="platformStatus" placeholder="平台上架" size="large" clearable
                    style="width: 200px;margin-right: 10px;">
                    <el-option label="上架" value="1" />
                    <el-option label="下架" value="2" />
                </el-select>
                <el-select class="force-style-input " v-model="wangyiStatus" placeholder="网易上架" size="large" clearable
                    style="width: 200px;margin-right: 10px;">
                    <el-option label="上架" value="1" />
                    <el-option label="下架" value="2" />
                </el-select>
                <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始时间"
                    end-placeholder="结束时间" size="large" style="width: 270px;margin-bottom: 10px;" clearable
                    :disabled-date="disabledDate" />
                <el-button size="large" style="margin:0 0 10px 10px;" @click="resetBtn">重置</el-button>
                <el-button type="primary" size="large" style="margin:0 0 10px 10px;" :loading="showLoading"
                    @click="searchBtn"><el-icon class="cancelgu">
                        <Search />
                    </el-icon>搜索</el-button>
            </div>
        </div>
        <div class="count">统计：{{ count }}条</div>

        <el-table :data="filterTableData" :header-cell-style="{ background: '#F5F7FA' }" v-loading="showLoading"
            style="width: 100%;margin-bottom: 10px;" row-key="spuId" border :empty-text="texts">

            <!-- 合并列 -->
            <el-table-column type="expand" width="50" fixed>
                <template #default="{ row }">
                    <div style="background-color: rgba(253, 246, 236,.6); padding: 10px 0; border-radius: 4px;padding-left: 50px;">
                        <el-table :data="row.skuList"
                            :header-cell-style="{ background: '#F2F6FC', color: '#606266', fontSize: '12px', fontWeight: 'normal' }"
                            :cell-style="{ fontSize: '12px' }"
                            border >

                            <!-- 子表格列 -->
                            <el-table-column label="SKUID" prop="skuId" align="center" width="150"></el-table-column>
                            <!-- 规格图片 -->
                            <el-table-column label="规格图片" align="center" :show-overflow-tooltip='true' width="300">
                                <template #default="scope">
                                    <template v-if="scope.row.skuPicUrl">
                                        <el-image style="width: 50px; height: 50px" :src="scope.row.skuPicUrl"
                                            fit="cover" :preview-src-list="[scope.row.skuPicUrl]" preview-teleported
                                            hide-on-click-modal />
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </template>
                            </el-table-column>
                            <!-- 渠道协议价 -->
                            <el-table-column label="渠道协议价" prop="discountPrice" align="center"
                                :show-overflow-tooltip='true' width="180"></el-table-column>
                            <!-- 平台售价 -->
                            <el-table-column label="平台售价" prop="platformPrice" align="center"
                                :show-overflow-tooltip='true' width="250"></el-table-column>
                            <!-- 平台积分售价 -->
                            <el-table-column label="平台积分售价" prop="platformIntegral" align="center"
                                :show-overflow-tooltip='true' width="150"></el-table-column>
                            <!-- 网易建议售价 -->
                            <el-table-column label="网易建议售价" prop="channelPrice" align="center"
                                :show-overflow-tooltip='true' width="150"></el-table-column>
                            <!-- 线上换货 -->
                            <el-table-column label="线上换货" prop="attrProhibitOnlineExchange" align="center"
                                :show-overflow-tooltip='true' width="150">
                                <template #default="scope">
                                    <el-tag type="success"
                                        v-show="scope.row.attrProhibitOnlineExchange == 0">允许</el-tag>
                                    <el-tag type="danger"
                                        v-show="scope.row.attrProhibitOnlineExchange == 1">不允许</el-tag>
                                </template>
                            </el-table-column>
                            <!-- 线上退货 -->
                            <el-table-column label="线上退货" prop="attrProhibitOnlineReturn" align="center"
                                :show-overflow-tooltip='true' width="150">
                                <template #default="scope">
                                    <el-tag type="success" v-show="scope.row.attrProhibitOnlineReturn == 0">允许</el-tag>
                                    <el-tag type="danger" v-show="scope.row.attrProhibitOnlineReturn == 1">不允许</el-tag>
                                </template>
                            </el-table-column>
                            <!-- 平台上架状态 -->
                            <el-table-column label="平台上架状态" prop="skuPlatformListingStatus" align="center"
                                :show-overflow-tooltip='true' width="150">
                                <template #default="scope">
                                    <el-tag type="success" v-show="scope.row.skuPlatformListingStatus == 1">上架</el-tag>
                                    <el-tag type="danger" v-show="scope.row.skuPlatformListingStatus == 2">下架</el-tag>
                                </template>
                            </el-table-column>
                            <!-- 网易上架状态 -->
                            <el-table-column label="网易上架状态" prop="skuPartnerListingStatus" align="center"
                                :show-overflow-tooltip='true' width="150">
                                <template #default="scope">
                                    <el-tag type="success" v-show="scope.row.skuPartnerListingStatus == 1">上架</el-tag>
                                    <el-tag type="danger" v-show="scope.row.skuPartnerListingStatus == 2">下架</el-tag>
                                </template>
                            </el-table-column>
                            <!-- 税率 -->
                            <el-table-column label="税率" prop="invoiceRate" align="center" :show-overflow-tooltip='true'
                                width="150">
                                <template #default="scope">
                                    <span>{{ scope.row.invoiceRate }}</span>
                                </template>
                            </el-table-column>
                            <!-- 库存 -->
                            <el-table-column label="库存" prop="inventory" align="center" :show-overflow-tooltip='true'
                                width="150"></el-table-column>
                            <!-- 创建时间 -->
                            <el-table-column label="创建时间" prop="createTime" align="center" :show-overflow-tooltip='true'
                                width="300" :formatter="reach">
                            </el-table-column>
                            <!-- 操作 -->
                            <el-table-column label="操作" align="center" width="199" :show-overflow-tooltip='true'>
                                <template #default="scope">
                                    <el-button size="default" class="bulur" @click="editPartner(scope.row)">
                                        <el-icon>
                                            <EditPen />
                                        </el-icon>查看更多
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </template>
            </el-table-column>
            <!-- 独立的商品ID列 -->
            <el-table-column label="商品ID" prop="spuId" width="150" fixed>
                <template #default="{ row }">
                    {{ row.spuId }}
                </template>
            </el-table-column>
            <el-table-column label="商品名称" prop="name" align="center" :show-overflow-tooltip='true'
                width="300"></el-table-column>
            <el-table-column label="规格图片" align="center" :show-overflow-tooltip='true' width="180">
                <template #default="scope">
                    <template v-if="scope.row.spuPicUrl">
                        <el-image style="width: 50px; height: 50px" :src="scope.row.spuPicUrl" fit="cover"
                            :preview-src-list="[scope.row.spuPicUrl]" preview-teleported hide-on-click-modal />
                    </template>
                    <template v-else>-</template>
                </template>
            </el-table-column>
            <el-table-column label="商品描述" prop="simpleDesc" align="left" :show-overflow-tooltip='true'
                width="250"></el-table-column>
            <el-table-column label="所属网易类目" prop="categoryName" align="center" :show-overflow-tooltip='true'
                width="300"></el-table-column>
            <el-table-column label="平台上架状态" prop="spuPlatformListingStatus" align="center" :show-overflow-tooltip='true'
                width="150">
                <template #default="scope">
                    <el-tag type="success" v-show="scope.row.spuPlatformListingStatus == 1">上架</el-tag>
                    <el-tag type="danger" v-show="scope.row.spuPlatformListingStatus == 2">下架</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="渠道协议价" prop="discountPrice" align="center" :show-overflow-tooltip='true'
                width="150"></el-table-column>
            <el-table-column label="平台售价" prop="platformPrice" align="center" :show-overflow-tooltip='true'
                width="150"></el-table-column>
            <el-table-column label="平台积分售价" prop="platformIntegral" align="center" :show-overflow-tooltip='true'
                width="150"></el-table-column>
            <el-table-column label="毛利率" prop="grossMargin" align="center" :show-overflow-tooltip='true' width="150">
                <template #default="scope">
                    <span>{{ scope.row.grossMargin }}</span>
                </template>
            </el-table-column>
            <el-table-column label="网易建议售价" prop="channelPrice" align="center" :show-overflow-tooltip='true'
                width="150"></el-table-column>
            <el-table-column label="网易上架状态" prop="spuPartnerListingStatus" align="center" :show-overflow-tooltip='true'
                width="150">
                <template #default="scope">
                    <el-tag type="success" v-show="scope.row.spuPartnerListingStatus == 1">上架</el-tag>
                    <el-tag type="danger" v-show="scope.row.spuPartnerListingStatus == 2">下架</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="SKU数量" prop="skuCount" align="center" :show-overflow-tooltip='true'
                width="150"></el-table-column>
            <el-table-column label="创建时间" prop="createTime" align="center" :show-overflow-tooltip='true' width="200"
                :formatter="reach">
            </el-table-column>
        </el-table>

        <el-pagination hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[5, 10, 15, 20]"
            :current-page="currentPage" :page-size="pagesize" :total="count" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />

        <div>
            <s3-layer v-model="visible" title="所属类目" :shadeClose="true" :area="['500px', '80vh']">
                <el-tree :data="texture" :props="defaultProps" accordion @node-click="dendrogram" />
            </s3-layer>
        </div>
    </div>
</template>

<script setup>
import { Search, EditPen } from '@element-plus/icons-vue'
import { ref, onMounted } from 'vue';
import moments from 'moment'
import { ElMessage } from 'element-plus';
import {
    getwangyiGoodsData, getwangyiCategoryInfo
} from "../../../../request/api";
import {
    useRouter,
} from "vue-router";
import qs from 'qs';
const texts = ref('暂无数据');
const router = useRouter()
const visible = ref(false);
const texture = ref([]);
const defaultProps = {
    label: 'categoryName',
    children: 'subCategories'
}
const goodsName = ref('');
const goodsId = ref('');
const negotiatedPriceSmall = ref('');
const negotiatedPriceBig = ref('');
const platformStatus = ref('');
const wangyiStatus = ref('');
const time = ref([]);
const categoryId = ref('');
const categoryName = ref('');
const currentPage = ref(1);
const pagesize = ref(5);
const filterTableData = ref([]);
const count = ref(0);
const showLoading = ref(true);
const selectRef = ref(null);

const dendrogram = (node) => {
    categoryId.value = node.categoryId;
    categoryName.value = node.categoryName;
    visible.value = false;
}

const openDialog = (event) => {
    event.preventDefault();
    visible.value = true;
    if (selectRef.value) {
        selectRef.value.hideDropdown();
    }
}

const dataInfo = () => {
    let startTime = '';
    let endTime = '';
    if (time.value.length === 2) {
        startTime = Math.floor(moments(time.value[0]).startOf('day').valueOf() / 1000);
        endTime = Math.floor(moments(time.value[1]).endOf('day').valueOf() / 1000);
    }

    let params = {
        name: goodsName.value,
        spuId: goodsId.value,
        categoryId: categoryId.value,
        startTime: startTime,
        endTime: endTime,
        minimumDiscountPrice: negotiatedPriceSmall.value,
        maximumDiscountPrice: negotiatedPriceBig.value,
        spuPlatformListingStatus: platformStatus.value,
        spuPartnerListingStatus: wangyiStatus.value,
        page: Number(currentPage.value),
        limit: Number(pagesize.value),

    }
    getwangyiGoodsData(qs.stringify(params)).then((res) => {
        if (res.data.code === 0) {
            filterTableData.value = res.data.data.goodsPage.list;
            count.value = res.data.data.goodsPage.totalCount;
            showLoading.value = false;
        } else {
            ElMessage.error(res.data.msg);
        }
    });
}

const getWangyiCategory = () => {
    getwangyiCategoryInfo().then((res) => {
        if (res.data.code === 0) {
            texture.value = res.data.data.publicCategoryList;
        } else {
            ElMessage.error(res.data.msg);
        }
    });
}

const disabledDate = (time) => {
    return time.getTime() > Date.now();
};

const searchBtn = () => {
    showLoading.value = true;
    currentPage.value = 1;
    dataInfo();
}

const resetBtn = () => {
    goodsName.value = '';
    goodsId.value = '';
    categoryId.value = '';
    categoryName.value = '';
    negotiatedPriceSmall.value = '';
    negotiatedPriceBig.value = '';
    platformStatus.value = '';
    wangyiStatus.value = '';
    time.value = [];
    currentPage.value = 1;
    pagesize.value = 5;
    showLoading.value = true;
    dataInfo();
}

const handleSizeChange = (val) => {
    showLoading.value = true;
    pagesize.value = val;
    dataInfo();
}

const handleCurrentChange = (val) => {
    currentPage.value = val;
    showLoading.value = true;
    dataInfo();
}

const reach = (row, column, cellValue) => {
    if (cellValue) {
        return moments(cellValue * 1000).format("YYYY-MM-DD HH:mm")
    }
    return '';
};

const editPartner = () => {
    router.push({ path: '/platform/add' })
}

onMounted(() => {
    dataInfo();
    getWangyiCategory();
})
</script>

<style lang="scss" scoped>
/* 修复展开箭头动画 */
::v-deep .el-table__expand-icon {
    transition: transform 0.3s;

    &.el-table__expand-icon--expanded {
        transform: rotate(90deg);
    }
}

/* 确保展开内容区域样式 */
::v-deep .el-table__expanded-cell {
    // padding: 10px !important;
    //   background-color: #fafafa;

    .el-table {
        // margin: 10px 0;
    }
}

::v-deep .el-input__inner {
    height: 40px;
}

.bulur {
    color: #409eff;
    border: none;
    --el-button-bg-color: none;
    --el-button-hover-bg-color: none;
    --el-button-hover-text-color: none;
}

.bulur:hover {
    color: #a0cfff;
}

.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}



.header_btn {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.common_ipt {
    width: 200px;
    height: 40px !important;
    margin-right: 10px;
    margin-bottom: 10px;
}

.common_ipt3 {
    width: 200px;
}

.force-style-input {
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
}

.count {
    font-size: 14px;
    color: #909399;
    margin-bottom: 15px;
}
</style>